/* unplugin-vue-components disabled */import { render } from "./CardHeader.vue?vue&type=template&id=82c853de&scoped=true"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"

import "./CardHeader.vue?vue&type=style&index=0&id=82c853de&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c853de"]])

export default __exports__